import { createSlice } from '@reduxjs/toolkit';

export const { actions, reducer } = createSlice({
  name: 'marketProducts',
  initialState: {
    shopRows: [],
    checkedShopRows: [],
    checkedProductsRows: [],
    extraFilter: false,
    malls: [],
    selectedMalls: [],
    selectedRows: [],
  },
  reducers: {
    updateState: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
});

export const {
  updateState,
} = actions;

export default reducer;
